/**
 * Generated from StartScreenLayout.fla
 */
export function StartScreenLayout(this: IStartScreenLayout) {
	const duck = this.duck;
	if (!duck[0] && duck.elementFactory) {
		duck[0] = duck.elementFactory(0,undefined);
	}
	if (duck[0]) {
		StartScreenLayout_duck1.call(duck[0] as IStartScreenLayout_duck1);
		duck[0].x = 110.9;
		duck[0].y = 143.4;
		duck[0].width = 203.00;
		duck[0].height = 110.45;
		if (duck[0].onLayout) duck[0].onLayout();
	}
	if (!duck[1] && duck.elementFactory) {
		duck[1] = duck.elementFactory(1,undefined);
	}
	if (duck[1]) {
		StartScreenLayout_duck2.call(duck[1] as IStartScreenLayout_duck2);
		duck[1].x = 449.5;
		duck[1].y = 130.25;
		duck[1].width = 207.00;
		duck[1].height = 107.50;
		if (duck[1].onLayout) duck[1].onLayout();
	}
	if (!duck[2] && duck.elementFactory) {
		duck[2] = duck.elementFactory(2,undefined);
	}
	if (duck[2]) {
		StartScreenLayout_duck3.call(duck[2] as IStartScreenLayout_duck3);
		duck[2].x = 247.75;
		duck[2].y = 137.85;
		duck[2].width = 160.50;
		duck[2].height = 129.50;
		if (duck[2].onLayout) duck[2].onLayout();
	}
	if (!duck[3] && duck.elementFactory) {
		duck[3] = duck.elementFactory(3,undefined);
	}
	if (duck[3]) {
		StartScreenLayout_duck4.call(duck[3] as IStartScreenLayout_duck4);
		duck[3].x = 595;
		duck[3].y = 137.1;
		duck[3].width = 167.00;
		duck[3].height = 124.00;
		if (duck[3].onLayout) duck[3].onLayout();
	}
	if (!duck[4] && duck.elementFactory) {
		duck[4] = duck.elementFactory(4,undefined);
	}
	if (duck[4]) {
		StartScreenLayout_duck5.call(duck[4] as IStartScreenLayout_duck5);
		duck[4].x = 783.75;
		duck[4].y = 134.9;
		duck[4].width = 214.50;
		duck[4].height = 155.00;
		if (duck[4].onLayout) duck[4].onLayout();
	}
	const bg = this.bg;
	StartScreenLayout_bg.call(this.bg);
	bg.x = 512;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const logo = this.logo;
	StartScreenLayout_logo.call(this.logo);
	logo.x = 501.5;
	logo.y = 288.75;
	logo.width = 723.00;
	logo.height = 133.50;
	if (logo.onLayout) logo.onLayout();
	const playButton = this.playButton;
	StartScreenLayout_playButton.call(this.playButton);
	playButton.x = 512;
	playButton.y = 456.25;
	playButton.width = 246.00;
	playButton.height = 161.50;
	if (playButton.onLayout) playButton.onLayout();
	const setupButton = this.setupButton;
	StartScreenLayout_setupButton.call(this.setupButton);
	setupButton.x = 512;
	setupButton.y = 613.5;
	setupButton.width = 268.50;
	setupButton.height = 114.50;
	if (setupButton.onLayout) setupButton.onLayout();
	const matt = this.matt;
	StartScreenLayout_matt.call(this.matt);
	matt.x = 79.35;
	matt.y = 768;
	matt.width = 302.50;
	matt.height = 326.00;
	if (matt.onLayout) matt.onLayout();
	const jackie = this.jackie;
	StartScreenLayout_jackie.call(this.jackie);
	jackie.x = 205;
	jackie.y = 768;
	jackie.width = 316.00;
	jackie.height = 297.50;
	if (jackie.onLayout) jackie.onLayout();
	const inez = this.inez;
	StartScreenLayout_inez.call(this.inez);
	inez.x = 855.5;
	inez.y = 768;
	inez.width = 313.00;
	inez.height = 332.50;
	if (inez.onLayout) inez.onLayout();
	const digit = this.digit;
	StartScreenLayout_digit.call(this.digit);
	digit.x = 941.6;
	digit.y = 435.25;
	digit.width = 187.50;
	digit.height = 203.50;
	if (digit.onLayout) digit.onLayout();
	return this;
}
function StartScreenLayout_bg(this: IStartScreenLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-bg@2x.jpg", 0.500, 0.500);
	return this;
}
function StartScreenLayout_logo(this: IStartScreenLayout_logo) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-logo.png", 0.500, 0.502);
	return this;
}
function StartScreenLayout_playButton(this: IStartScreenLayout_playButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-play-btn.png", 0.500, 0.500);
	return this;
}
function StartScreenLayout_setupButton(this: IStartScreenLayout_setupButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-setupmygame-btn.png", 0.500, 0.500);
	return this;
}
function StartScreenLayout_matt(this: IStartScreenLayout_matt) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-matt.png", 0.500, 1.000);
	return this;
}
function StartScreenLayout_jackie(this: IStartScreenLayout_jackie) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-jackie.png", 0.500, 1.000);
	return this;
}
function StartScreenLayout_inez(this: IStartScreenLayout_inez) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-inez.png", 0.500, 1.000);
	return this;
}
function StartScreenLayout_duck1(this: IStartScreenLayout_duck1) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-duck5.png", 0.500, 0.500);
	return this;
}
function StartScreenLayout_duck2(this: IStartScreenLayout_duck2) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-duck4.png", 0.500, 0.500);
	return this;
}
function StartScreenLayout_duck3(this: IStartScreenLayout_duck3) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-duck3.png", 0.500, 0.500);
	return this;
}
function StartScreenLayout_duck4(this: IStartScreenLayout_duck4) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-duck2.png", 0.500, 0.500);
	return this;
}
function StartScreenLayout_duck5(this: IStartScreenLayout_duck5) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-duck1.png", 0.500, 0.500);
	return this;
}
function StartScreenLayout_digit(this: IStartScreenLayout_digit) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-digit.png", 0.500, 0.500);
	return this;
}
interface IStartScreenLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IStartScreenLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IStartScreenLayoutSprite extends IStartScreenLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IStartScreenLayoutText extends IStartScreenLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IStartScreenLayoutPolygon extends Array<number> {
}
interface IStartScreenLayout {
	readonly duck: IStartScreenLayoutArray<IStartScreenLayout_duck1|IStartScreenLayout_duck2|IStartScreenLayout_duck3|IStartScreenLayout_duck4|IStartScreenLayout_duck5>;
	readonly bg: IStartScreenLayout_bg;
	readonly logo: IStartScreenLayout_logo;
	readonly playButton: IStartScreenLayout_playButton;
	readonly setupButton: IStartScreenLayout_setupButton;
	readonly matt: IStartScreenLayout_matt;
	readonly jackie: IStartScreenLayout_jackie;
	readonly inez: IStartScreenLayout_inez;
	readonly digit: IStartScreenLayout_digit;
}
interface IStartScreenLayout_bg extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_logo extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_playButton extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_setupButton extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_matt extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_jackie extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_inez extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_duck1 extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_duck2 extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_duck3 extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_duck4 extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_duck5 extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_digit extends IStartScreenLayoutSprite {
}
